import React from "react";
import useSmallNav from "../../../../hooks/useSmallNav";
import { Container } from "react-bootstrap";
import UnderlinedHeader from "../../../molecules/UnderlinedHeader/UnderlinedHeader";
import InfoHero from "../../../molecules/info/InfoHero/InfoHero";
import c300 from "../../../../assets/info/300c-hero.jpg";
import InfoGrid from "../../../atoms/info/InfoGrid/InfoGrid";
import InfoHeader from "../../../atoms/info/InfoHeader/InfoHeader";
import InfoCard from "../../../molecules/info/InfoCard/InfoCard";
import InfoFooter from "../../../organisms/InfoFooter/InfoFooter";
import bush1 from "../../../../assets/info/chrysler-300c/300c-front-wishbone.jpg";
import bush2 from "../../../../assets/info/chrysler-300c/300c-rear-wishbone.jpg";
import { popularVehicle } from "../../../../vars/popularVehicles";
import styled from "styled-components";

const Chrysler300C = () => {
  useSmallNav("Chrysler 300C");

  return (
    <section className={"popular"}>
      <Container>
        <UnderlinedHeader text={"CHRYSLER 300C"} bolder />
        <InfoHero image={c300} />
        <InfoGrid>
          <div>
            <InfoHeader
              text={
                "The secret formula for long lasting Chrysler 300C urethane bushes"
              }
            />
            <p>
              Pedders Suspension has extensively researched and developed its
              complete range of suspension products to suit the Chrysler 300C,
              otherwise known as the LX platform. This includes Chrysler 300C,
              Dodge Charger and Dodge Magnum.
            </p>
            <p>
              The Pedders Suspension range of products for these cars includes,
              springs, dampers and bushes. Many of these components offer
              improved life and/or performance over the original offering.
              Whether you are seeking replacement parts with extended life, or
              an improvement in performance, the Pedders Suspension have the
              answer.
            </p>
            <p>
              The most common failures on the 300C are the tension strut bushes,
              closely followed by the lower damper bushes. Pedders offer
              replacements with significantly longer longevity & that's a
              guarantee!
            </p>
            <p>
              Not sure which bush to order? Then check out our 300C front
              suspension component identifier diagram. All bushes are supplied
              as a pair. The price you see displayed will include bushes for
              both sides of the car.
            </p>
            <p>
              Not sure what is involved in fitting these bushes? Where
              necessary, instructions are supplied with each pack of bushes.
            </p>
            <p>
              Looking to improve the handling of your car? Then again, Pedders
              has a range of products to help you achieve this. Whether its just
              a set of lowering springs for enhanced looks, or a full coilover
              kit, we have it right here!
            </p>
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/g1aSCo4S2_E"
              title={"Chrysler 300c Video 1"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/KnT6sI4QaYk"
              title={"Chrysler 300c Video 2"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
          <div>
            {popularVehicle
              .find((e) => e.make === "Chrysler")
              .models.find((e) => e.display === "Chrysler 300C")
              .popular.map((item) => (
                <InfoCard
                  key={item.text}
                  name={item.text}
                  to={item.link}
                  photo={item.photo}
                />
              ))}
            <Gray>
              <InfoHeader
                size="smaller"
                text={"Pedders front suspension bush location"}
              />
              <div>
                <StyledImgParts
                  src={bush1}
                  alt="Pedders front suspension bush"
                />
              </div>
            </Gray>
            <Gray>
              <InfoHeader
                size="smaller"
                text={"Pedders rear suspension bush location"}
              />
              <div>
                <StyledImgParts
                  src={bush2}
                  alt="Pedders rear suspension bush"
                />
              </div>
            </Gray>
          </div>
        </InfoGrid>
        {/* <InfoFooter make="Chrysler" model="300C" /> */}
      </Container>
    </section>
  );
};

export default Chrysler300C;

const StyledImgParts = styled.img`
  width: 100%;
`;

const Gray = styled.div`
  padding: 25px;
  border-radius: 5px;
  background-color: #f4f4f4;
  margin: 30px 0;
`;
